import accessTokenStorage from 'containers/services/security/access-token-storage';
import { callApi } from 'helpers/saga-helpers';
import {
  REQUEST_ADD_PROVISIONAL_CLAIM,
  REQUEST_GET_PROVISIONAL_CLAIM,
} from 'containers/ProvisionalClaimsPage/constants';
import { put, select, takeLeading } from 'redux-saga/effects';
import {
  requestGetProvisionalClaim,
  setProvisionalClaim,
} from 'containers/ProvisionalClaimsPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import { isLawyer } from 'containers/AppContainer/utils';

export function* requestProvisionalClaim(action: any): Generator {
  const { page, limit } = action;
  const token = !isLawyer()
    ? accessTokenStorage.get().token
    : yield select(makeSelectKeycloakToken());
  if (!token) return;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      page,
      limit,
      isLawyer: isLawyer(),
    }),
  };
  const path = `/corporeal/provisional-claim/get-all-provisional-claims`;
  yield callApi(path, {}, options, [], setProvisionalClaim);
}

export function* requestProvisionalClaimSaga() {
  yield takeLeading(REQUEST_GET_PROVISIONAL_CLAIM, requestProvisionalClaim);
}

export function* addProvisionalClaim(action: any): Generator<unknown> {
  const { payload: data, successCallback } = action;
  const token = accessTokenStorage.get().token;
  if (!token) return;
  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...data.payload }),
  };
  const path = `/corporeal/provisional-claim`;
  const errorResponse = yield callApi(path, {}, options);

  if (!errorResponse) {
    yield put(requestGetProvisionalClaim(0, 10));
    yield successCallback();
  }
}

export function* addProvisionalClaimSaga() {
  yield takeLeading(REQUEST_ADD_PROVISIONAL_CLAIM, addProvisionalClaim);
}

export default [requestProvisionalClaimSaga, addProvisionalClaimSaga];
